<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="6">
                    <b-row>
                        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-search-box-label">Data Dal</label>
                            <date-picker v-model="dataRiferimentoDal" format="DD/MM/YYYY" value-type="timestamp" placeholder="Inserisci Data Dal" type="date" class="w-100"></date-picker>
                        </b-col>
                        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-search-box-label">Data Al</label>
                            <date-picker v-model="dataRiferimentoAl" format="DD/MM/YYYY" value-type="timestamp" placeholder="Inserisci Data Al" type="date" class="w-100"></date-picker>
                        </b-col>
                        <b-col xs="12" sm="12" md="4" lg="4" xl="4" style="display: flex; align-items: flex-end; gap: 8px">
                            <b-form-checkbox v-model="mostraTutte" size="lg" switch>
                                <span style="font-size: 1rem; vertical-align: middle; height: 100%; display: inline-block; margin-top: -3px; margin-right: 10px">Mostra tutte</span>
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col lg="3">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
            <b-form @submit.prevent="onClickCercaIntervallo" @reset.prevent="onResetFiltro">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-search-box-label">Cognome</label>
                        <b-form-input v-model="filtroPaziente.cognome" type="search" placeholder="Cognome"></b-form-input>
                    </b-col>
                    <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-search-box-label">Nome</label>
                        <b-form-input v-model="filtroPaziente.nome" type="search" placeholder="Nome"></b-form-input>
                    </b-col>
                    <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-search-box-label">Identificativo Appuntamento</label>
                        <b-form-input v-model="filtroPaziente.identificativoAppuntamento" type="search" placeholder="Identificativo"></b-form-input>
                    </b-col>
                    <b-col xs="12" sm="12" md="3" lg="3" xl="3" style="display: flex; align-items: flex-end; gap: 8px">
                        <b-button type="submit" variant="info" size="sm"> <b-icon icon="search"></b-icon> Cerca </b-button>
                        <b-button type="reset" variant="danger" size="sm">Reset</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="appuntamenti" :fields="fields" :tbody-tr-class="impostaClasseRiga" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + (row.index + 1) }}
                    </template>
                    <template #cell(identificativoAppuntamento)="row">
                        {{ row.item.cognome }} {{ row.item.nome }}
                        <i style="font-weight: 700"> {{ row.item.identificativoAppuntamento }}</i>
                    </template>
                    <template #cell(riferimento)="row">
                        <strong style="font-size: small; display: inline-block">
                            {{ formattaData(row.item.dataRiferimento) }}
                            <br />
                            {{ row.item.dalleOre }} - {{ row.item.alleOre }}
                        </strong>
                    </template>
                    <template #cell(prestazione)="row">
                        <strong style="font-size: small; display: inline-block">
                            {{ row.item.descrizionePrestazione }}
                            <br />
                            <small>{{ row.item.codicePrestazione }}</small>
                        </strong>
                    </template>
                    <template #cell(actions)="row">
                        <!-- {{ item }} -->
                        <b-container class="bv-example-row" style="gap: 8px">
                            <!-- <b-button size="sm" v-b-tooltip.hover title="Visualizza Dettaglio" variant="outline-secondary">
                                <i class="bi bi-eye"></i>
                            </b-button>
                            <b-button size="sm" v-b-tooltip.hover title="Modifica" variant="outline-success">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button> -->
                            <!-- <b-button size="sm" v-b-tooltip.hover title="Presa in carico" variant="outline-info"
                @click="onClickAccetta(item)">
                <i class="fas fa-link"></i>
              </b-button> -->
                            <b-button v-if="row.item.statoAttuale === 'CANCELLATO' && row.item.idAppuntamentoRiferimento" v-b-tooltip.hover title="Dettaglio Spostamento" variant="btn btn-info waves-effect waves-light width-sm no-text" @click="onClickGetInfoAppuntamento(row.item)">
                                <b-icon icon="info-circle"></b-icon>
                            </b-button>
                            <b-button v-b-tooltip.hover title="Presa in carico" variant="btn btn-info waves-effect waves-light width-sm no-text" @click="onClickAccetta(row.item)">
                                <i class="fas fa-link"></i>
                            </b-button>
                            <b-button v-b-tooltip.hover title="Sposa Appuntamento" variant="btn btn-purple waves-effect waves-light width-sm no-text" @click="onClickSpostaAppuntamento(row.item)">
                                <b-icon icon="gear"></b-icon>
                            </b-button>
                            <b-button v-b-tooltip.hover title="Elimina Appuntamento" variant="btn btn-danger waves-effect waves-light width-sm no-text" @click="onClickEliminaAppuntamento(row)">
                                <b-icon icon="trash"></b-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
            <agenda-appuntamento-accettazione-box-modal-component ref="cmpAgendaAppuntamentoAccettazioneBoxModal"></agenda-appuntamento-accettazione-box-modal-component>
            <b-modal ref="mdlSpostaAppuntamento" id="mdlSpostaAppuntamento" size="lg" @shown="onShownSpostaAppuntamento" @hide="onHideSpostaAppuntamento" style="height: 100%; width: 100%" no-close-on-backdrop no-close-on-esc hide-header-close title="Sposta Appuntamento">
                <b-row>
                    <b-col cols="12" class="p-3">
                        <h4 class="w-100 d-flex justify-content-center align-content-center">
                            Appuntamento per <span style="font-weight: 700 !important; margin-left: 3px"> {{ appuntamentoSelezionato.identificativoAppuntamento }} </span>
                        </h4>
                    </b-col>
                    <b-col cols="6">
                        <b-row>
                            <b-col cols="12" class="p-2">
                                <label class="w-100 sa-ft-label">Prestazione e Codice</label>
                                <strong> {{ appuntamentoSelezionato.descrizionePrestazione }} </strong>
                                <small>({{ appuntamentoSelezionato.codicePrestazione }})</small>
                            </b-col>
                            <b-col cols="12">
                                <b-row>
                                    <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                                        <b-form-group label="Agenda" class="sa-ft-label">
                                            <b-form-input disabled :value="agenda.titolo"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                                        <b-form-group label="Data Riferimento" class="sa-ft-label">
                                            <date-picker v-model="dataRiferimentoSpostaAppuntamentoDate" format="DD-MM-YYYY" value-type="timestamp" placeholder="Seleziona Data" type="date" class="w-100"> </date-picker>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="6">
                        <b-row>
                            <b-col cols="12" class="mb-3">
                                <div class="p-2 border rounded" style="background-color: #f8f9fa">
                                    <label class="w-100 font-weight-bold">Attuale Pianificazione </label>
                                    <b-row>
                                        <b-col md="6">
                                            <small class="text-muted d-block">Data Riferimento</small>
                                            <small>{{ getGiornoSettimana(appuntamentoSelezionato.dataRiferimento).toUpperCase() }},</small>
                                            <strong class="w-100 d-block">{{ formattaData(appuntamentoSelezionato.dataRiferimento) }}</strong>
                                        </b-col>
                                        <b-col md="6">
                                            <small class="text-muted d-block">Orario</small>
                                            <strong>
                                                {{ getOrario(appuntamentoSelezionato.dataOraInizio) }}
                                                -
                                                {{ getOrario(appuntamentoSelezionato.dataOraFine) }}
                                            </strong>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                            <b-col cols="12" class="mb-3">
                                <div class="p-2 border rounded" style="background-color: #f8f9fa">
                                    <label class="w-100 font-weight-bold">Nuova Pianificazione</label>
                                    <b-row>
                                        <b-col md="6">
                                            <small class="text-muted d-block">Data Riferimento</small>
                                            <small v-if="spostaAppuntamentoJsonData.dataRiferimento != null">{{ getGiornoSettimana(spostaAppuntamentoJsonData.dataRiferimento).toUpperCase() }},</small>
                                            <strong v-if="spostaAppuntamentoJsonData.dataRiferimento != null" class="w-100 d-block">{{ formattaData(spostaAppuntamentoJsonData.dataRiferimento) }}</strong>
                                        </b-col>
                                        <b-col md="6">
                                            <small class="text-muted d-block">Orario</small>
                                            <strong v-if="spostaAppuntamentoJsonData.dataOraInizio != null && spostaAppuntamentoJsonData.dataOraFine != null">
                                                {{ getOrario(spostaAppuntamentoJsonData.dataOraInizio) }}
                                                -
                                                {{ getOrario(spostaAppuntamentoJsonData.dataOraFine) }}
                                            </strong>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <label>Seleziona Nuova Disponibilità</label>
                        <div class="b-table-sticky-header" style="height: 300px">
                            <b-table selectable ref="tblDisponibilita" select-mode="single" striped hover :items="disponibilitaAgendaItems[0].disponibilita" :fields="fieldDisponibilita" @row-selected="onDisponibilitaSelected" head-variant="light">
                                <template #cell(seleziona)="row">
                                    <b-icon :icon="row.rowSelected ? 'check-circle-fill' : 'circle'" :variant="row.rowSelected ? 'primary' : 'secondary'"></b-icon>
                                </template>
                                <template #cell(dataRiferimento)="row">
                                    <strong style="font-size: small; display: inline-block">
                                        {{ formattaData(row.item.dataRiferimento) }}
                                        <br />
                                        <small> {{ getGiornoSettimana(row.item.dataRiferimento).toUpperCase() }}</small>
                                        <br />
                                        <strong style="font-size: small; display: inline-block"> {{ row.item.dalleOre }} - {{ row.item.alleOre }} </strong>
                                    </strong>
                                </template>
                            </b-table>
                        </div>
                    </b-col>
                </b-row>
                <template #modal-footer>
                    <div style="display: flex; gap: 6px; justify-content: flex-end; align-items: center">
                        <b-button variant="danger" @click="onAnnullaSpostaAppuntamento">Annulla</b-button>
                        <b-button variant="success" @click="spostaAppuntamento"> Sposta Appuntamento </b-button>
                    </div>
                </template>
            </b-modal>
            <b-modal ref="mdlInfoAppuntamentoSpostato" id="mdlInfoAppuntamentoSpostato" size="md" @shown="onShownAppuntamentoInfoSpostato" @hide="onHideAppuntamentoInfoSpostato" style="height: 100%; width: 100%" title="Info Appuntamento">
                <b-row>
                    <b-col cols="12" class="mb-3">
                        <div class="p-2 border rounded" style="background-color: #f8f9fa">
                            <label class="w-100 font-weight-bold">Appuntamento Spostato alla data :</label>
                            <b-row>
                                <b-col md="6">
                                    <small class="text-muted d-block">Data Riferimento</small>
                                    <small>{{ getGiornoSettimana(infoAppuntamentoRiferimento.dataRiferimento).toUpperCase() }},</small>
                                    <strong class="w-100 d-block">{{ formattaData(infoAppuntamentoRiferimento.dataRiferimento) }}</strong>
                                </b-col>
                                <b-col md="6">
                                    <small class="text-muted d-block">Orario</small>
                                    <strong>
                                        {{ getOrario(infoAppuntamentoRiferimento.dataOraInizio) }}
                                        -
                                        {{ getOrario(infoAppuntamentoRiferimento.dataOraFine) }}
                                    </strong>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                </b-row>
            </b-modal>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import moment from "moment";
import AgendaAppuntamentoAccettazioneBoxModalComponent from "./AgendaAppuntamentoAccettazioneBoxModalComponent.vue";
import axios from "axios";
import toast from "../../../template/layout/utility/sa-toast";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    components: { AgendaAppuntamentoAccettazioneBoxModalComponent, DatePicker },
    props: {
        prestazione: {
            type: String,
            default: () => {
                return "";
            },
        },
        agenda: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    mixins: [UtilityMixin],
    data() {
        return {
            pathResourceAgendaAppuntamenti: "/agendaappuntamenti",
            appuntamentoSelezionato: {},
            idAgenda: null,
            appuntamenti: [],
            dataRiferimentoSpostaAppuntamentoDate: new Date().getTime(),
            nuovaDisponibilitaSelezionata: null,
            spostaAppuntamentoJsonData: {
                idAgenda: null,
                dataRiferimento: null,
                alleOre: null,
                dalleOre: null,
                dataOraFine: null,
                dataOraInizio: null,
            },
            rows: 0,
            perPage: 10,
            pathResourceAgendaDisponibilita: "/agendadisponibilita",
            disponibilitaAgendaItems: [{ disponibilita: [] }],
            mostraTutte: false,
            currentPage: 1,
            dataRiferimento: new Date().getTime(),
            dataRiferimentoDal: new Date().getTime(),
            dataRiferimentoAl: new Date().getTime(),
            dataRiferimentoSpostaAppuntamento: null,
            filtro: {},
            filtroPaziente: { cognome: null, nome: null, identificativoAppuntamento: null },
            items: [],
            listKey: 0,
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 1rem",
                },
                {
                    label: "Identificativo",
                    key: "identificativoAppuntamento",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Prestazione",
                    key: "prestazione",
                    sortable: false,
                    thStyle: "width: 12rem",
                },
                {
                    label: "Appuntamento",
                    key: "riferimento",
                    sortable: false,
                    thStyle: "width: 8rem",
                },
                {
                    label: "Note",
                    key: "note",
                    sortable: false,
                    thStyle: "width: 4rem",
                },
                {
                    label: "",
                    class: "sa-table-column-action-double",
                    key: "actions",
                },
            ],
            fieldDisponibilita: [
                { key: "seleziona", label: "", thStyle: "width: 50px" },
                { key: "dataRiferimento", label: "Slot" },
            ],
            infoAppuntamentoSelezionato: {},
            infoAppuntamentoRiferimento: {},
        };
    },
    mounted() {
        this.idAgenda = this.$route.params.id;
    },
    watch: {
        currentPage: function () {
            this.loadData();
        },
        mostraTutte: function () {
            if (this.currentPage !== 1) {
                this.currentPage = 1;
            } else {
                this.loadData();
            }
        },
        dataRiferimentoSpostaAppuntamentoDate: function (params) {
            this.dataRiferimentoSpostaAppuntamento = moment(params).format("YYYY-MM-DD");
        },
        dataRiferimentoSpostaAppuntamento: function (params) {
            let me = this;
            if (params) {
                me.loadAgendaDisponibilita();
            }
        },
    },
    methods: {
        init(dataRiferimento) {
            // Il filtro persistente viene aggiornato solo quando viene fornita una data.
            if (dataRiferimento) {
                this.dataRiferimento = dataRiferimento;
                this.dataRiferimentoDal = moment(dataRiferimento, "YYYY-MM-DD").valueOf();
                this.dataRiferimentoAl = moment(dataRiferimento, "YYYY-MM-DD").valueOf();
            }

            if (this.currentPage !== 1) {
                this.currentPage = 1;
            } else {
                this.loadData();
            }
        },
        onClickCercaIntervallo() {
            if (this.dataRiferimentoDal && this.dataRiferimentoAl && moment(this.dataRiferimentoDal).isAfter(moment(this.dataRiferimentoAl), "day")) {
                toast.warning("La Data Dal non può essere successiva alla Data Al");
                return;
            }
            if (this.currentPage !== 1) {
                this.currentPage = 1;
            } else {
                this.loadData();
            }
        },
        onResetFiltro() {
            this.filtroPaziente = { cognome: null, nome: null, identificativoAppuntamento: null };
            // Le date tornano alla data di riferimento corrente dell'agenda.
            this.dataRiferimentoDal = moment(this.dataRiferimento).valueOf();
            this.dataRiferimentoAl = moment(this.dataRiferimento).valueOf();
            if (this.currentPage !== 1) {
                this.currentPage = 1;
            } else {
                this.loadData();
            }
        },
        onClickGetInfoAppuntamento(item) {
            this.infoAppuntamentoSelezionato = item;
            this.$refs.mdlInfoAppuntamentoSpostato.show();
        },
        onShownAppuntamentoInfoSpostato() {
            let appuntamento = this.infoAppuntamentoSelezionato;
            let link = process.env.VUE_APP_PATH_API + "/agendaappuntamenti/" + appuntamento.idAppuntamentoRiferimento;
            this.openShowModalLoading();
            axios
                .get(link)
                .then((response) => {
                    this.infoAppuntamentoRiferimento = response.data.data;
                    this.closeShowModalLoading();
                })
                .catch((err) => {
                    toast.error(err.response.data.messaggio);
                    this.closeShowModalLoading();
                });
        },
        onHideAppuntamentoInfoSpostato() {
            this.infoAppuntamentoSelezionato = {};
            this.infoAppuntamentoRiferimento = {};
        },
        loadData() {
            this.openShowModalLoading();

            let filtro = {
                idAgenda: this.idAgenda,
                // Deve essere presente in ogni richiesta al backend.
                dataRiferimento: this.dataRiferimento,
                dataRiferimentoDal: this.dataRiferimentoDal ? moment(this.dataRiferimentoDal).startOf("day").valueOf() : null,
                dataRiferimentoAl: this.dataRiferimentoAl ? moment(this.dataRiferimentoAl).startOf("day").valueOf() : null,
                mostraCancellati: this.mostraTutte,
                cognome: this.filtroPaziente.cognome ? this.filtroPaziente.cognome.trim() : null,
                nome: this.filtroPaziente.nome ? this.filtroPaziente.nome.trim() : null,
                identificativoAppuntamento: this.filtroPaziente.identificativoAppuntamento ? this.filtroPaziente.identificativoAppuntamento.trim() : null,
                page: this.currentPage,
                forPage: this.perPage,
            };

            UtilityMixin.methods.loadDataResources(this.pathResourceAgendaAppuntamenti, filtro, this.loadDataSuccess, this.loadDataError);
        },
        loadDataSuccess(response) {
            this.appuntamenti = response.data.data.list;
            this.rows = response.data.data.recordsNumber;
            this.closeShowModalLoading();
        },
        loadDataError(error) {
            console.log(error);
            if (error.response && error.response.data && error.response.data.messaggio) {
                toast.error(error.response.data.messaggio);
            }
            this.closeShowModalLoading();
        },
        convertiInTimestamp(data, ora) {
            const dateFinal = `${data}T${ora}:00`;
            return new Date(dateFinal).getTime();
        },
        getGiornoSettimana(dataString) {
            if (!dataString) return "--";
            const giornoSettimana = moment(dataString).locale("it").format("dddd");
            return giornoSettimana;
        },
        getOrario(data) {
            return moment(data).format("HH:mm");
        },
        getDataFormattata(data) {
            return moment(data).format("HH:mm");
        },
        onDisponibilitaSelected(items) {
            if (items && items.length > 0) {
                this.nuovaDisponibilitaSelezionata = items[0];
                this.spostaAppuntamentoJsonData.dataRiferimento = this.nuovaDisponibilitaSelezionata.dataRiferimento;
                this.spostaAppuntamentoJsonData.alleOre = this.nuovaDisponibilitaSelezionata.alleOre;
                this.spostaAppuntamentoJsonData.dalleOre = this.nuovaDisponibilitaSelezionata.dalleOre;
                this.spostaAppuntamentoJsonData.dataOraFine = this.convertiInTimestamp(this.nuovaDisponibilitaSelezionata.dataRiferimento, this.nuovaDisponibilitaSelezionata.alleOre);
                this.spostaAppuntamentoJsonData.dataOraInizio = this.convertiInTimestamp(this.nuovaDisponibilitaSelezionata.dataRiferimento, this.nuovaDisponibilitaSelezionata.dalleOre);
                this.spostaAppuntamentoJsonData.idAgenda = this.idAgenda;
            } else {
                this.nuovaDisponibilitaSelezionata = null;
            }
        },
        onClickAccetta(item) {
            let me = this;
            me.$refs.cmpAgendaAppuntamentoAccettazioneBoxModal.init(item);
        },
        onShownSpostaAppuntamento() {
            this.dataRiferimentoSpostaAppuntamentoDate = new Date().getTime();
        },
        onClickSpostaAppuntamento(row) {
            this.appuntamentoSelezionato = row;
            this.spostaAppuntamentoJsonData = JSON.parse(JSON.stringify(row));
            delete this.spostaAppuntamentoJsonData.id;
            delete this.spostaAppuntamentoJsonData.primaryKey;
            this.$refs.mdlSpostaAppuntamento.show();
        },
        onClickEliminaAppuntamento(row) {
            this.$bvModal
                .msgBoxConfirm(`Sei sicuro di procedere alla cancellazione dell'appuntamento indice ${row.index + 1} ?`, {
                    title: "Conferma Cancellazione Associazione",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        this.eliminaAppuntamento(row.item.id);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        impostaClasseRiga(item, type) {
            type;
            if (!item) return "";
            if (item.statoAttuale == "CANCELLATO" && !item.idAppuntamentoRiferimento) {
                return "riga-cancellata";
            } else if (item.statoAttuale == "CANCELLATO" && item.idAppuntamentoRiferimento) {
                return "riga-spostata";
            }
            return "";
        },
        onAnnullaSpostaAppuntamento() {
            this.$refs.mdlSpostaAppuntamento.hide();
        },
        onHideSpostaAppuntamento() {
            this.appuntamentoSelezionato = {};
        },
        spostaAppuntamento() {
            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + "/agendaappuntamenti/sposta/" + this.appuntamentoSelezionato.id;
            axios
                .put(link, this.spostaAppuntamentoJsonData)
                .then(() => {
                    this.$refs.mdlSpostaAppuntamento.hide();
                    toast.success("Operazione di 'Sposta Appuntamento' avvenuto con successo !");
                    this.loadData();
                    this.closeShowModalLoading();
                })
                .catch((e) => {
                    console.log(e);
                    this.closeShowModalLoading();
                });
        },
        loadAgendaDisponibilita() {
            let filter = {
                language: "it",
                idAgenda: this.idAgenda,
                periodo: "G",
                riferimento: this.dataRiferimentoSpostaAppuntamento,
                codicePrestazione: this.prestazione,
            };
            (this.disponibilitaAgendaItems = [{ disponibilita: [] }]), this.loadDataResources(this.pathResourceAgendaDisponibilita, filter, this.loadAgendaDisponibilitaSuccess, this.loadAgendaDisponibilitaError);
        },
        loadAgendaDisponibilitaSuccess(response) {
            let me = this;
            me.disponibilitaAgendaItems = response.data.data;
        },
        loadAgendaDisponibilitaError(error) {
            console.log(error);
        },
        formattaData(dataString) {
            if (!dataString) return "";
            // Separa l'anno, il mese e il giorno [yyyy, mm, dd]
            const parti = dataString.split("-");
            // Li riunisce al contrario: dd/mm/yyyy
            return `${parti[2]}/${parti[1]}/${parti[0]}`;
        },
        eliminaAppuntamento(id) {
            let link = process.env.VUE_APP_PATH_API + "/agendaappuntamenti/" + id;

            axios.delete(link).then(() => {
                toast.success("Eliminato con successo !");
                this.loadData();
            });
        },
    },
};
</script>
<style>
/* Stile generale per la riga cancellata */
.riga-cancellata {
    opacity: 0.5;
    background-color: #f8f9fa !important;
}
.riga-cancellata td {
    color: #868e96 !important;
    vertical-align: middle !important;
}
/* Prepariamo la prima cella per ospitare l'indicatore curvo */
.riga-cancellata td:first-child {
    position: relative;
    padding-left: 15px;
    /* Lascia un po' di spazio per non far sovrapporre il testo alla curva */
}
/* Creiamo il bordo rosso arrotondato */
.riga-cancellata td:first-child::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    /* Spessore del bordo */
    height: 100%;
    /* Copre tutta l'altezza della riga */
    background-color: #dc3545;
    /* Arrotonda l'angolo in alto a sinistra e in basso a sinistra */
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    pointer-events: none;
}
/* Disabilitiamo visivamente i bottoni */
.riga-cancellata .btn {
    opacity: 0.25;
    pointer-events: none;
    filter: grayscale(100%);
}
/**/
/* Stile generale per la riga cancellata */
/* 1. Stile della riga spostata - Rimuoviamo l'opacity globale da qui */
.riga-spostata {
    background-color: #f8f9fa !important;
}
/* Applichiamo l'opacità e il colore solo ai testi delle celle normali */
.riga-spostata td {
    color: #868e96 !important;
    opacity: 0.6;
    vertical-align: middle !important;
}
/* 2. Indicatore curvo sulla prima cella (rimane bello acceso) */
.riga-spostata td:first-child {
    position: relative;
    padding-left: 15px;
    opacity: 1;
    /* Forza la piena visibilità sulla prima cella che contiene il bordo */
}
.riga-spostata td:first-child::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    height: 100%;
    background-color: #dc9935;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    pointer-events: none;
}
/* ==========================================
   GESTIONE PULSANTI (Azione mirata)
   ========================================== */
/* Spostiamo l'opacità e il blocco solo sulla cella delle azioni */
.riga-spostata td.sa-table-column-action-double {
    opacity: 1 !important;
    /* La cella delle azioni torna visibile al 100% */
}
/* 3. Di base spegniamo TUTTI i bottoni dentro la riga spostata */
.riga-spostata .btn {
    opacity: 0.25;
    pointer-events: none;
    filter: grayscale(100%);
}
/* 4. ECCEZIONE: Il primo bottone in assoluto dentro il contenitore torna attivo e visibile */
.riga-spostata .bv-example-row .btn:first-of-type {
    opacity: 1 !important;
    pointer-events: auto !important;
    filter: none !important;
}
</style>
